/**
 * Store for the application. Stores app level variables that can be changed
 * and propagated throughout the application.
 */

import React, { createContext, useContext, useReducer } from 'react';

export const initialState = {
  messages: [],
  flags: [],
};

export const reducer = (state, action) => {
  switch (action.type) {
    case 'addMessage':
      return {
        ...state,
        messages: [...state.messages, action.message],
      };

    case 'removeMessage':
      return {
        ...state,
        messages: state.messages.filter((m) => m !== action.message),
      };

    case 'clearMessages':
      return {
        ...state,
        messages: [],
      };

    case 'addFlag':
      return {
        ...state,
        // We want to have always only one flag so we just override
        // the entire array with the current flag.
        flags: [action.flag],
      };

    case 'removeFlag':
      return {
        ...state,
        flags: state.flags.filter((m) => m !== action.flag),
      };

    case 'clearFlags':
      return {
        ...state,
        flags: [],
      };

    default:
      return state;
  }
};

const StoreContext = createContext(initialState);

export const StoreProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    // @ts-ignore
    <StoreContext.Provider value={{ state, dispatch }}>
      {children}
    </StoreContext.Provider>
  );
};

export const useStore = () => {
  // @ts-ignore
  const { state, dispatch } = useContext(StoreContext);
  return { state, dispatch };
};
